import { Component, Input, OnInit, ViewChild, ChangeDetectorRef, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {CreateDisclosureSharedService} from './create-disclosure-shared.service';
import {DSTStatement} from '../../../shared/models/dst-statement.model';
import {DSTDynamicComponentResolverService, DSTSavePayload} from './dst-dynamic-component-resolver.service';
import {Subscription} from 'rxjs';
import {TrackerTabsService, TrackerTabState} from '../../tracker-tabs.service';
import {DSTFormState} from '../../../shared/models/dst-form-state.model';
import { MessageService } from '../../../shared/services/message.service';
import { ModalComponent } from '@appkit4/angular-components/modal';
import {DSTSharedService} from '../../../shared/dst-shared.service';
import {Alert} from '../../statement-tracker.service';

@Component({
    selector: 'dst-create-disclosure-shared',
    templateUrl: './create-disclosure-shared.component.html',
    styleUrls: ['./create-disclosure-shared.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CreateDisclosureSharedComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);


  @Input() rowObj!: DSTStatement;

  activeIndex: number = 0;
  formStateArray!: DSTFormState[];
  private trackerTabId!: string;
  private onSaveSubs!: Subscription;
  isChildEditing: boolean = false;
  alert: Alert;

  constructor(private sharedService: CreateDisclosureSharedService,
              private trackerTabsService: TrackerTabsService,
              private dCRService: DSTDynamicComponentResolverService,
              private messageService: MessageService,
              private dstSharedService: DSTSharedService,
              private cdr: ChangeDetectorRef) {
    this.alert = this.dstSharedService.alert;
    this.formStateArray = this.sharedService.getFormStateArray();
    this.activeIndex = this.trackerTabsService.getActiveTrackerTabChildIndex() || 0;
    if(this.activeIndex) this.sharedService.setActiveIndex(this.activeIndex);
    this.onSaveSubs = this.dCRService.onDisclosureSave.subscribe((payload: DSTSavePayload) => {
      // add child statement tabs
      if (payload && payload.trackerTab.id === this.trackerTabId) {
        (!payload.redirectToChild) && payload.childFormStates.forEach((childFormState: DSTFormState) => {
          payload.trackerTab.addFormState(childFormState.taxYear, childFormState.taxYearId,
            childFormState.returnPeriodId || 1, childFormState.statementId, childFormState.formId,
            childFormState.formName, childFormState.formType, childFormState.formTypeId, childFormState.cseId || 0, true);
        });
        // Update formStateArray reference after adding child statements
        this.formStateArray = this.sharedService.getFormStateArray();
        
        // Force change detection to ensure DOM is updated
        this.cdr.detectChanges();
        
        // Use setTimeout with longer delay to ensure tab components are fully initialized
        setTimeout(() => {
          try {
            const newIndex = this.trackerTabsService.getActiveTrackerTabChildIndex();
            if (newIndex !== undefined && newIndex !== null && this.formStateArray && this.formStateArray[newIndex]) {
              this.activeIndex = newIndex; // set first child form as active
              (payload.redirectToChild) && this.sharedService.redirectToNextChild(newIndex, false);
            } else {
              console.warn('Cannot switch tab: invalid index or formStateArray not ready', newIndex, this.formStateArray);
            }
          } catch (error) {
            console.error('Error switching tabs after save:', error);
          }
        }, 100); // Increased delay to 100ms for tab initialization
      } else if (this.trackerTabsService.getActiveTrackerTab()?.activeTabIndex === 1) { //set second child form as active
        this.activeIndex = 2;//this.trackerTabsService.getActiveTrackerTabChildIndex()!;
        this.sharedService.redirectToNextChild(this.activeIndex, false);
        // this.trackerTabsService.setActiveTrackerTabChildIndex(0);//reset child index
      }
    });
  }

  ngOnInit() {
    const tab: TrackerTabState | null = this.trackerTabsService.getActiveTrackerTab();
    tab && (this.trackerTabId = tab.id);
    if (this.rowObj) {
      if (this.rowObj.placeHolder || this.rowObj.statementId === '0') {
        // create;
        this.sharedService.setCSStatementId(this.rowObj.csStatementId);
        this.sharedService.setLeId(this.rowObj.leId);
      } else {
        // view/update
        this.sharedService.setCSStatementId(0);
        this.sharedService.setLeId('');
      }
      this.formStateArray = this.sharedService.getFormStateArray();
    }


    this.messageService.subscribe(this.trackerTabId,"is-child-statement-edit",(payload)=>{
      this.isChildEditing = payload;

      this.messageService.broadcast(this.trackerTabId,"is-child-statement-edit-parent",payload);
    });
  }

  ngOnDestroy(): void {
    this.onSaveSubs?.unsubscribe();
    this.messageService.unsubscribe(this.trackerTabId, "is-child-statement-edit");
  }

  onTabChanged(event: any): void {
    const index = typeof event === 'number' ? event : event?.index;
    if (index !== undefined && this.formStateArray && this.formStateArray[index]) {
      this.activeIndex = index;
      this.sharedService.setActiveIndex(index);
    } else {
      console.warn('Invalid tab change event or formStateArray not ready:', event, this.formStateArray);
    }
  }

}
